module.exports = __webpack_public_path__ + "static/media/ruleImg4.d796bc2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ruleImg4.png
// module id = 1855
// module chunks = 0 1